import axios from 'axios';
import {bindEvent} from "../utils/functions";

class Autocomplete {
  constructor(selectElement) {
    this.selectElement = selectElement
    this.apiUrl = selectElement.dataset.url
    this.what = selectElement.dataset.what
    this.disableAdding = selectElement.dataset.disableAdding.toLowerCase() === "True".toLowerCase();
    this.filters = {}
    this.filterInputEls = new Map() // <string, HTMLElement>
    this.initUI()
    this.addEventListeners()
    selectElement.classList.add('finished')
    if (this.selectElement.dataset.value !== undefined) {
      let init_val = this.selectElement.dataset.value.replaceAll(/[^0-9,]/g, '')
      if (init_val) {
        let vals_list = []
        init_val.split(",").forEach((item) => {
          vals_list.push({value: item})
        })
        this.addValues(vals_list)
      }
    }
  }

  initUI() {
    const is_small = this.selectElement.classList.contains("is-small")
    // Skrýt původní select
    this.selectElement.style.display = 'none'

    // Vytvoření a zobrazení inputu a label divu
    this.labelDiv = document.createElement('div')
    this.labelDiv.innerHTML = this.selectElement.dataset.placeholder || 'Start typing...'
    this.labelDiv.classList.add('label-div', 'input', is_small ? 'is-small' : null)
    this.labelDiv.style.height = 'auto'

    this.input = document.createElement('input')
    this.input.setAttribute('type', 'text')
    this.input.classList.add('input', is_small ? 'is-small' : null)
    this.input.placeholder = this.selectElement.dataset.placeholder || 'Start typing...'

    this.showLabel()

    this.filterContent = document.createElement('div')
    this.filterContent.classList.add('is-hidden', 'zeta-autocomplete-upper-menu', 'has-background')
    this.filterContent.classList.add('menu')
    this.populateFilterDropdown();

    // Vytvoření a skrytí dropdown menu
    this.dropdownContent = document.createElement('div')
    this.dropdownContent.classList.add('zeta-autocomplete-menu')
    this.dropdownContent.classList.add('menu')

    this.dropdownWrapper = document.createElement('div')
    this.dropdownWrapper.classList.add('zeta-autocomplete')

    let wrapper = document.createElement('div')
    wrapper.classList.add('zeta-autocomplete-input-wrapper', 'control', 'is-expanded')
    wrapper.append(this.labelDiv, this.input, this.dropdownContent, this.filterContent)
    this.inputWrapper = wrapper;

    this.btnSpec = document.createElement('button')
    this.btnSpec.type = 'button'
    this.btnSpec.classList.add('button', 'has-text-warning', is_small ? 'is-small' : null)
    this.btnSpec.innerHTML = '<span class="icon"><i class="fa fa-barcode-read"></i></span>'
    let btnSpecWrapper = document.createElement('div')
    btnSpecWrapper.appendChild(this.btnSpec)
    btnSpecWrapper.classList.add('control', 'is-flex')

    this.btnFilter = document.createElement('button')
    this.btnFilter.type = 'button'
    this.btnFilter.classList.add('button', 'has-text-white-bold', is_small ? 'is-small' : null)
    this.btnFilter.innerHTML = '<span class="icon"><i class="fa fa-filter"></i></span>'
    this.btnFilter.style.height = 'auto'
    let btnFilterWrapper = document.createElement('div')
    btnFilterWrapper.appendChild(this.btnFilter)
    btnFilterWrapper.classList.add('control', 'is-flex')

    this.btnClipboard = document.createElement('button')
    this.btnClipboard.type = 'button'
    this.btnClipboard.classList.add('button', 'has-text-white-bold', is_small ? 'is-small' : null, 'is-hidden')
    this.btnClipboard.innerHTML = '<span class="icon"><i class="far fa-clipboard-list-check"></i></span>'
    let btnClipboardWrapper = document.createElement('div')
    btnClipboardWrapper.appendChild(this.btnClipboard)
    btnClipboardWrapper.classList.add('control', 'is-flex')

    this.btnClear = document.createElement('button')
    this.btnClear.type = 'button'
    this.btnClear.classList.add('button', 'is-danger', 'is-outlined', is_small ? 'is-small' : null)
    this.btnClear.innerHTML = '<span class="icon"><i class="fa fa-xmark"></i></span>'
    let btnClearWrapper = document.createElement('div')
    btnClearWrapper.appendChild(this.btnClear)
    btnClearWrapper.classList.add('control', 'is-flex')

    this.btnLatest = document.createElement('button')
    this.btnLatest.type = 'button'
    this.btnLatest.classList.add('button', is_small ? 'is-small' : null)
    this.btnLatest.innerHTML = '<span class="icon"><i class="fa fa-chevron-down"></i></span>'
    let btnLatestWrapper = document.createElement('div')
    btnLatestWrapper.appendChild(this.btnLatest)
    btnLatestWrapper.classList.add('control', 'is-flex')

    let btnAddWrapper = null
    if(!this.disableAdding) {
      btnAddWrapper = document.createElement('div');
      this.btnAdd = document.createElement('button')
      this.btnAdd.type = 'button'
      this.btnAdd.classList.add('button', 'is-primary', 'is-outlined', is_small ? 'is-small' : null)
      this.btnAdd.style.zIndex = "2";
      this.btnAdd.innerHTML = '<span class="icon"><i class="fa fa-plus"></i></span>'
      btnAddWrapper.appendChild(this.btnAdd)
      btnAddWrapper.classList.add('control', 'is-flex')
    }

    let acWrapper = document.createElement('div')
    acWrapper.classList.add('zeta-autocomplete-controls', 'field', 'has-addons')
    if(!this.disableAdding) {
      acWrapper.append(btnAddWrapper, btnClipboardWrapper, wrapper, btnLatestWrapper, btnFilterWrapper, /*btnSpecWrapper,*/ btnClearWrapper)
    } else {
      acWrapper.append(btnClipboardWrapper, wrapper, btnLatestWrapper, btnFilterWrapper, /*btnSpecWrapper,*/ btnClearWrapper)
    }

    this.dropdownWrapper.append(acWrapper)

    this.selectElement.parentNode.insertBefore(this.dropdownWrapper, this.selectElement)

    axios.get(`/autocomplete/clipboard?what=${this.what}`).then(response => {
      if (response.status === 200) {
        this.btnClipboard.classList.remove('is-hidden')
        this.btnClipboard.dataset.value = response.data[this.what];
      }
      else {
        btnClipboardWrapper.parentNode.removeChild(btnClipboardWrapper)
      }
    }).catch(exc => {
      btnClipboardWrapper.parentNode.removeChild(btnClipboardWrapper)
    })
  }

  addEventListeners() {
    this.input.addEventListener('input', debounce(this.loadData.bind(this),200))
    bindEvent(this.dropdownContent, 'click', '.clickable', true, this.itemSelected.bind(this))
    this.labelDiv.addEventListener('click', this.showInput.bind(this))
    this.btnClear.addEventListener('click', this.clearValue.bind(this))
    this.btnSpec.addEventListener('click', () => {
      document.getElementById("modalQR").classList.add('is-active')
      startQrVideo()
    })
    this.btnFilter.addEventListener('click', () => {
      // this is because when clicking outside the dropdown, it closes and then immediately opens again, so class removal must happen after the dropdown is hidden
      setTimeout(() => this.filterContent.classList.remove('is-hidden'), 0);
    });
    this.btnLatest.addEventListener('click', () => {
      this.input.value = ''
      this.loadData(true)
    })
    this.btnClipboard.addEventListener('click', this.clipboardClicked.bind(this))
    if (!this.disableAdding) {
      this.btnAdd.addEventListener('click', () => {
        ModalDialog.instance.loadForm(`/new/${this.what}?__modal&__autocomplete`, this)
        ModalDialog.instance.show()
      })
    }
    document.addEventListener('click', (event) => {
      if(!this.filterContent.contains(event.target)){
        this.filterContent.classList.add('is-hidden');
      }
      if (! this.dropdownContent.contains(event.target))
        this.hideMenu()
    })
    this.selectElement.addEventListener('changeValue', (evt) => {
      let value = evt.detail.value;
      this.addValues(value);
      // if(Array.isArray(value)){
      //   let values = []
      //   value.forEach(val => {
      //     values.push({value: val})
      //   })
      //   this.addValues(values);
      // } else {
      //   this.addValue(value);
      // }
    });
    this.selectElement.addEventListener('clearValue', () => {
      this.clearValue();
    });
//    this.input.addEventListener('blur', () => this.dropdownWrapper.classList.remove('is-active'))
  }

  showMenu() {
    this.dropdownWrapper.classList.add('is-active');
  }

  hideMenu() {
    this.dropdownWrapper.classList.remove('is-active');
  }

  showLabel() {
    this.input.classList.add('is-hidden')
    this.labelDiv.classList.remove('is-hidden')
    this.input.value = ''
  }

  showLoading(isLoading) {
    this.inputWrapper.classList.toggle('is-loading', isLoading)
  }

  showInput(focus=true) {
    this.labelDiv.classList.add('is-hidden')
    this.input.classList.remove('is-hidden')
    if(focus)
      this.input.focus()
  }

  clearValue() {
    this.selectElement.innerHTML = ''
    this.input.value = ''
    this.input.classList.remove('is-danger')
    this.labelDiv.innerHTML = this.selectElement.dataset.placeholder || 'Start typing...'
    this.labelDiv.dataset.data = null
    this.showInput(false)
    this.selectElement.dispatchEvent(new CustomEvent('changed', { detail: { value: null, data: null, mode: 'remove' } }))
  }

  setFilter(key, value) {
    this.filters[key] = value
  }

  clearFilter() {
    this.filters = {}
  }

  assignFilteringInput(selectElement, key) {
    this.filterInputEls.set(key, selectElement)
  }

  assignFilteringAutocomplete(selectElement, key) {
    bindEvent(selectElement, "changed", null, true, () => {
      const value = selectElement.value
      if (value === '' || value === null || value === undefined) {
        delete this.filters[key]
        console.log("removing filter:", key)
      } else {
        this.setFilter(key, value)
        console.log("adding filter:", key, value)
      }
    })
  }

  __set_dataset(DOMElement, data) {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        DOMElement.dataset[key] = data[key];
      }
    }
  }

  async addValues(dataList) {
    // [{value: val1, label: label1, data: data1}, ...]
    const promises = dataList.map(item => this._addValue(item.value, item?.label || null, item?.data || null));  // Spuštění všech _addValue volání

    try {
      this.selectElement.classList.add("loading")
      this.showLoading(true);
      const results = await Promise.all(promises);  // Počkání na všechny výsledky

      const returned_vals = results.map(res => res?.value || null);
      const returned_data = results.map(res => res?.data || null);

      this.selectElement.dispatchEvent(new CustomEvent('changed', {
        detail: { value: returned_vals, data: returned_data, mode: 'add' }
      }));
    } catch (error) {
      console.error("Chyba při přidávání hodnot:", error);
    } finally {
      this.selectElement.classList.remove("loading")
      this.showLoading(false);
    }

  }

  addValue(val, label=null, data=null) {
    this.addValues([{value: val, label: label, data: data}])
  }

  _addValue(val, label = null, data = null) {
    console.log("addValue", val, label, data);
    const newOption = document.createElement("option");
    newOption.value = val;
    newOption.text = label;
    this.__set_dataset(newOption, data)
    newOption.selected = true;
    this.selectElement.appendChild(newOption);

    if (label === null) {
      return axios.get(this.apiUrl, { params: { id: val } })
        .then(response => {
          this.labelDiv.innerHTML = response.data[0].label;
          this.__set_dataset(this.labelDiv, response.data[0].data);
          this.__set_dataset(newOption, response.data[0].data);
          return { value: val, data: response.data[0].data };
        })
        .catch(error => {
          console.error("Invalid value!", error);
          this.selectElement.dataset.value = null;
          return null;
        });
    } else {
      this.labelDiv.innerHTML = label
      this.__set_dataset(this.labelDiv, data)
      return Promise.resolve({ value: val, data: data });
    }
  }

  removeValue(val) {
    this.selectElement.dispatchEvent(new CustomEvent('changed', { detail: { value: val, data: null, mode: 'remove' } }))
    return this.clearValue()
  }

  getValues() {
    // returns an array of ids of selected items
    return Array.from(this.selectElement.options).map(opt => parseInt(opt.value))
  }

  composeACParams() {
    const value = this.input.value.trim()
    const filters = {...this.filters}
    for (const [key, el] of this.filterInputEls.entries()) {
      // Don't add empty values
      try {
        if (el.value === '' || el.value === null || el.value === undefined) continue;
        if (el.type === 'checkbox' && !el.checked) continue;
        filters[key] = el.value
      } catch (e) {
        console.error("Error while setting filter", key, e)
      }
    }
    return { ...filters, term: value }
  }

  loadData(last_results=false) {
    if (! last_results && value.length < 1) return
    this.input.parentElement.classList.add('is-loading')

    // console.log("Looking for: ", this.input.value.trim());
    // console.log("Currently running:", this._runningLoadDataRequest)
    let runningLoadDataRequest = axios.get(this.apiUrl, { params: this.composeACParams() })
      .then(response => {
      if(this._runningLoadDataRequest && runningLoadDataRequest != this._runningLoadDataRequest) {
          // This could happen when two loadDatas ran in parallel and the former finished later than the latter
          // Thus we need to prevent loading data from incomplete input
          // console.log("this happened.")
          // console.log("former promise: ", this._runningLoadDataRequest)
          // console.log("latter promise: ", runningLoadDataRequest)
          return
        }
        // console.log("Apparently no promise conflict")
        // console.log("former promise: ", this._runningLoadDataRequest)
        // console.log("latter promise: ", runningLoadDataRequest)
        const contentType = response.headers['content-type'];
        if (contentType.includes('application/json')) {
          this.input.classList.remove('is-danger')
          this.populateDropdown(response.data, [])
        } else {
          this.populateDropdown([], ['Invalid response type. This is a bug, please report it.'])
        }
      })
      .catch(error => {
        console.error(error)
        this.input.classList.add('is-danger')
        if (error.response.status === 404)
          this.populateDropdown([], ['No matching results.'])
        else
          this.populateDropdown([], ['Error occurred, please report it.'])
      })
      .finally(() => {
        this.input.parentElement.classList.remove('is-loading')
      })
    this._runningLoadDataRequest = runningLoadDataRequest;
  }

  populateFilterDropdown() {
    this.filterContent.innerHTML = "<div class='zeta-autocomplete-menu-item is-flex is-justify-content-space-between'>" +
        "<span>Use default filter</span><input type='checkbox' class='checkbox'>" +
        "</div>";
    const checkbox = this.filterContent.querySelector('input');
    checkbox.checked = true;
    this.setFilter("__default_filter", true);
    checkbox.addEventListener('change', (event) => {
        if (event.target.checked) {
          this.setFilter("__default_filter", true);
        } else {
          delete this.filters["__default_filter"];
        }
    });
  }

  populateDropdown(data, errors) {
    this.dropdownContent.innerHTML = '' // Vymazat předchozí výsledky
    errors.forEach(err => {
      const optionDiv = document.createElement('div')
      optionDiv.classList.add('zeta-autocomplete-menu-item', 'has-background-danger', 'has-text-white')
      const err_p = document.createElement('p')
      err_p.innerHTML = err
      optionDiv.appendChild(err_p)
      this.dropdownContent.appendChild(optionDiv)
    });

    let last_cat = null
    let current_list = null
    for (let i = 0; i < data.length; i++) {
      const item = data[i]
      if (item.category !== last_cat) {
        last_cat = item.category
        const cat = document.createElement('div')
        cat.innerText = item.category
        cat.classList.add('menu-label', 'zeta-autocomplete-menu-category', 'has-background-light-soft')
        current_list = document.createElement('ul')
        current_list.classList.add('menu-list')
        this.dropdownContent.appendChild(cat)
        this.dropdownContent.appendChild(current_list)
      }
      const option = document.createElement('a')
      option.innerHTML = item.label
      this.__set_dataset(option, item.data)
      option.dataset.value = item.value
      option.classList.add('zeta-autocomplete-menu-item', 'clickable')
      const option_wrapper = document.createElement('li')
      option_wrapper.appendChild(option)
      current_list.appendChild(option_wrapper)
    }
    this.showMenu()
  }

  clipboardClicked(event) {
    axios.get(this.apiUrl, {params: {id__in: this.btnClipboard.dataset.value}}).then(response => {
      if (response.status === 200) {
        this.populateDropdown(response.data.map(item => ({... item, category: 'clipboard'})), [])
      }
    }).catch(exc => {
    })
  }

  itemSelected(event) {
    const optionDiv = event.target;
    const value = optionDiv.dataset.value;
    const label = optionDiv.innerHTML;
    const data = { ... optionDiv.dataset }

    // Aktualizace skrytého selectu a label divu
    this.addValue(value, label, data)

    // Skrýt dropdown a input
    if(!this.selectElement.multiple) {
      this.hideMenu();
    } else {
      setTimeout(() => {
        optionDiv.remove();
        if(this.dropdownContent.querySelectorAll('.zeta-autocomplete-menu-item').length === 0) {
          this.hideMenu();
        }
      }, 0);
    }
    this.showLabel();
  }
}


class Multicomplete extends Autocomplete {
  initUI() {
    super.initUI();
    console.log("Initializing Multicomplete")
    this.selectElement.multiple = "multiple"
    this.collection = document.createElement('div')
    this.collection.classList.add('zeta-autocomplete-collection')
    this.dropdownWrapper.appendChild(this.collection)
  }

  addEventListeners() {
    super.addEventListeners();
    bindEvent(this.collection, 'click', '.remove-item', true, (event) => {
      console.log("removing item!")
      this.removeValue(event.target.closest('.remove-item').dataset.value)
    })
  }

  __addLabel(val, label, data) {
    const collectedLabel = document.createElement('div')
    collectedLabel.classList.add('zeta-autocomplete-multi-label')
    collectedLabel.dataset.value = val
    this.__set_dataset(collectedLabel, data)
    collectedLabel.innerHTML = `
<div style='flex-grow: 2'>${label}</div>
<a href="#" role="button" class="remove-item has-text-danger" data-value="${val}">
    <span class="icon"><i class="fa fa-xmark"></i></span>
</a>`
    this.collection.appendChild(collectedLabel)
  }
    showLoading(isLoading, skeletonNum=1) {
        super.showLoading(isLoading);
        if(isLoading){
            for (let i = 0; i < skeletonNum; i++) {
                const collectedLabel = document.createElement('div');
                collectedLabel.classList.add('skeleton-block', 'zeta-autocomplete-multi-label');
                collectedLabel.style.margin = "5px 0";
                this.collection.appendChild(collectedLabel);
            }
        } else {
            this.collection.querySelectorAll(".skeleton-block")?.forEach(el => el.remove())
        }
    }

  _appendOption(val, label, data=null) {
      const newOption = document.createElement("option")
      newOption.value = val
      newOption.text = val
      newOption.selected = true
      this.selectElement.appendChild(newOption);
      this.__addLabel(val, label, data)
      this.__set_dataset(newOption, data)
  }

  async _addValues(dataList) {
    // [{value: val1, label: label1, data: data1}, ...]
    const unlabeledItemIds = dataList.filter((item) => !item.label)
    if(unlabeledItemIds.length > 0){
        // fetch all labels, it is not probable that some will come labeled and some not
        const res = await axios.post(this.apiUrl, {id__in: dataList.map(item => item.value).join(","), pg_size: 0})
        for(const item of res.data){
            if (this.selectElement.querySelector(`option[value="${item.value}"]`)) {
                console.warn(`value ${item.value} is already selected`);
                continue
            }
            this._appendOption(item.value, item.label, item.data)
        }
        return res.data
    } else{
        for(const item of dataList) {
            if (this.selectElement.querySelector(`option[value="${item.value}"]`)) {
                console.warn(`value ${item.value} is already selected`);
                continue
            }
            this._appendOption(item.value, item.label, item.data)
        }
        return dataList
    }
  }


    async addValues(dataList) {
        // [{value: val1, label: label1, data: data1}, ...]
        try {
            this.showLoading(true, dataList.length);
            this.selectElement.classList.add("loading")
            const results = await this._addValues(dataList);

            const returned_vals = results.map(res => res?.value || null);
            const returned_data = results.map(res => res?.data || null);

            this.selectElement.dispatchEvent(new CustomEvent('changed', {
                detail: { value: returned_vals, data: returned_data, mode: 'add' }
            }));
        } catch (error) {
            console.error("Chyba při přidávání hodnot:", error);
        } finally {
            this.showLoading(false);
            this.selectElement.classList.remove("loading")
        }
    }

  removeValue(val) {
    const opt = this.selectElement.querySelector(`option[value='${val}']`)
    if (opt !== null)
      opt.remove()
    const lbl = this.collection.querySelector(`.zeta-autocomplete-multi-label[data-value='${val}']`)
    if (lbl !== null)
      lbl.remove()
    this.selectElement.dispatchEvent(new CustomEvent('changed', { detail: { value: val, data: null, mode: 'remove' } }))
  }

  clearValue() {
    super.clearValue();
    this.collection.innerHTML = ''
    this.selectElement.dispatchEvent(new CustomEvent('changed', { detail: { value: null, data: null, mode: 'remove' } }))
  }

  showLabel() {
    super.showInput();
  }

  clipboardClicked(event) {
    let new_values = this.btnClipboard.dataset.value.split(",").map(v => ({value: v, label: null, data: null}))
    this.addValues(new_values)
  }

  composeACParams() {
    let params = super.composeACParams()
    const except = []
    for (let option of this.selectElement.selectedOptions) {
      except.push(option.value);
    }
    if (except.length)
      params.except = except.join(',')
    return params
  }
}

export { Autocomplete, Multicomplete }
